import { render } from "./PostToAxxesscare.vue?vue&type=template&id=c34f94f4&ts=true"
import script from "./PostToAxxesscare?vue&type=script&lang=ts&external"
export * from "./PostToAxxesscare?vue&type=script&lang=ts&external"

import "./PostToAxxesscare.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__